import { render, staticRenderFns } from "./NukiApiView.vue?vue&type=template&id=5048487e&lang=pug&"
import script from "./NukiApiView.vue?vue&type=script&lang=ts&"
export * from "./NukiApiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports